import ExtendableError from '../lib/ExtendableError';

export class FavouritesLimitExceededError extends ExtendableError { name = 'FavouritesLimitExceededError'; }
